import React from 'react';

import NextImageV2 from '../../../../ui/components/NextImageV2';

import styles from '../styles/HomeBannerImage.module.scss';

interface HomeBannerImageCmpProps {
  desktopBanner: string;
  mobileBanner: string;
}

function HomeBannerImageCmp({
  desktopBanner,
  mobileBanner,
}: HomeBannerImageCmpProps): React.ReactElement {
  return (
    <>
      <div className={styles['desktop']}>
        <NextImageV2
          src={desktopBanner}
          fill
          priority
          alt="Banner Image"
          className={styles['img']}
        />
      </div>
      <div className={styles['mobile']}>
        <NextImageV2
          src={mobileBanner}
          fill
          priority
          alt="Banner Image"
          className={styles['img']}
        />
      </div>
    </>
  );
}

export default HomeBannerImageCmp;
